
/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import ReadMoreModal, { ROT_RUT, EXPRESS_NOT_ROT_RUT } from '../read-more-modal/read-more-modal';
import InvoiceValidator from 'redux/modules/invoice/invoice-validator';
import _ from 'lodash';

export class Hsd extends React.Component {

  static propTypes = {
    setExpressPayment: PropTypes.func.isRequired,
    expressPayment: PropTypes.bool.isRequired,
    setRot: PropTypes.func.isRequired,
    setRut: PropTypes.func.isRequired,
    rot: PropTypes.bool.isRequired,
    rut: PropTypes.bool.isRequired,
    data: PropTypes.string.isRequired,
    apartmentNumber: PropTypes.string,
    accommodationType: PropTypes.string,
    cooperativeApartmentRegistrationNumber: PropTypes.string,
    submitted: PropTypes.bool.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      renderModal: false,
      renderExpressModal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.toggleExpressModal = this.toggleExpressModal.bind(this);
    this.renderExpressModal = this.renderExpressModal.bind(this);

    this.onChangeType = this.onChangeType.bind(this);
    this.onKeyUpData = this.onKeyUpData.bind(this);
    this.onKeyUpApartmentNumber = this.onKeyUpApartmentNumber.bind(this);
    this.onChangeAccommodationType = this.onChangeAccommodationType.bind(this);
    this.onKeyUpCooperativeApartmentRegistrationNumber = this.onKeyUpCooperativeApartmentRegistrationNumber.bind(this);
  }

  toggleModal () {
    this.setState({
      renderModal: !this.state.renderModal
    });
  }

  toggleExpressModal () {
    this.setState({
      renderExpressModal: !this.state.renderExpressModal
    });
  }

  renderModal () {
    if (this.state.renderModal) {
      return (
        <ReadMoreModal
          close={this.toggleModal}
          text={ROT_RUT}
        />
      );
    }
  }

  renderExpressModal () {
    if (this.state.renderExpressModal) {
      return (
        <ReadMoreModal
          close={this.toggleExpressModal}
          text={EXPRESS_NOT_ROT_RUT}
        />
      );
    }
  }

  onChangeType (e) {
    switch (e.target.value) {
      case 'rot':
        this.props.setRot(e.target.checked, this.props.data, this.props.apartmentNumber,
            this.props.cooperativeApartmentRegistrationNumber,
            _.isEmpty(this.props.accommodationType) ? 'house' : this.props.accommodationType);
        break;
      case 'rut':
        this.props.setRut(e.target.checked);
        break;
    }

    if (e.target.checked && this.props.expressPayment) {
      this.toggleExpressModal();
      this.props.setExpressPayment(false);
    }
  }

  onChangeAccommodationType (e) {
    this.props.setRot(this.props.rot, '', '', '', e.target.value);
  }

  onKeyUpData (e) {
    this.props.setRot(this.props.rot, e.target.value, this.props.apartmentNumber,
        this.props.cooperativeApartmentRegistrationNumber, this.props.accommodationType);
  }

  onKeyUpApartmentNumber (e) {
    this.props.setRot(this.props.rot, this.props.data, e.target.value,
        this.props.cooperativeApartmentRegistrationNumber, this.props.accommodationType);
  }

  onKeyUpCooperativeApartmentRegistrationNumber (e) {
    this.props.setRot(this.props.rot, this.props.data,
        this.props.apartmentNumber, e.target.value, this.props.accommodationType);
  }

  renderError () {
    let errorKey;
    let map =
      [this.props.rot,
        this.props.data,
        this.props.accommodationType,
        this.props.apartmentNumber,
        this.props.cooperativeApartmentRegistrationNumber
      ];

    if (this.props.submitted && !InvoiceValidator.validateHsd(...map)) {
      if (this.props.accommodationType === 'house') {
        errorKey = 'INVOICE_HSD_ROT_HOUSE';
      } else if (this.props.accommodationType === 'apartment') {
        errorKey = 'INVOICE_HSD_ROT_APARTMENT';
      }

      return (
        <p className="error"><Translate content={errorKey}/></p>
      );
    }
  }

  renderRot () {
    let datainputAccommodationHouse;
    let datainputAccommodationApartment;

    if (this.props.accommodationType === 'house') {
      datainputAccommodationHouse = (
        <input type='text'
          name='data'
          onKeyUp={this.onKeyUpData}
          defaultValue={this.props.data}
          placeholder={proxyCounterpart('HSD_PROPERTY_LABEL')} />
      );
    }

    if (this.props.accommodationType === 'apartment') {
      datainputAccommodationApartment = (
        <div>
          <input type='text'
            name='cooperativeApartmentRegistrationNumber'
            onKeyUp={this.onKeyUpCooperativeApartmentRegistrationNumber}
            defaultValue={this.props.cooperativeApartmentRegistrationNumber}
            placeholder={proxyCounterpart('HSD_BRF_ORG_NUMBER')} />
          <input type='text'
            name='apartmentNumber'
            onKeyUp={this.onKeyUpApartmentNumber}
            defaultValue={this.props.apartmentNumber}
            placeholder={proxyCounterpart('HSD_BRF_APARTMENT_NUMBER')} />
        </div>
      );
    }

    if (this.props.rot) {
      return (
        <div className="hsd-accommodation">
          <p><Translate content='HSD_CHOOSE_ACCOMMODATION'/></p>
          <div className='checkbox-wrapper'>
            <input id='house'
              type='checkbox'
              name='hsd_rot_type_of_accommodation'
              value='house'
              onChange={this.onChangeAccommodationType}
              checked={(this.props.accommodationType === 'house')}/>
            <label htmlFor='house'><span></span><Translate content='HSD_PROPERTY'/></label>
          </div>
          {datainputAccommodationHouse}
          <div className='checkbox-wrapper'>
            <input id='apartment'
              type='checkbox'
              name='hsd_rot_type_of_accommodation'
              value='apartment'
              onChange={this.onChangeAccommodationType}
              checked={(this.props.accommodationType === 'apartment')} />
            <label htmlFor='apartment'><span></span><Translate content='HSD_APARTMENT'/></label>
          </div>
          {datainputAccommodationApartment}
        </div>
      );
    }
  }

  render () {
    return (
      <div className='hsd-wrapper'>
        <div className='hsd'>
          <h3><Translate content='ROT_RUT'/></h3>
          <p><Translate content={this.props.translationPrefix + 'ROT_RUT_TEXT'}/></p>
          <div className='checkbox-wrapper'>
            <input id='rot'
              type='checkbox'
              name='hsd'
              value='rot'
              onChange={this.onChangeType}
              checked={this.props.rot} />
            <label htmlFor='rot'><span></span><Translate content='ROT'/></label>
          </div>
          {this.renderRot()}
          <div className='checkbox-wrapper'>
            <input id='rut'
              type='checkbox'
              name='hsd'
              value='rut'
              onChange={this.onChangeType}
              checked={this.props.rut} />
            <label htmlFor='rut'><span></span><Translate content='RUT'/></label>
          </div>
        </div>
        <div className='hsd-link'>
          <button className='pointer-link' onClick={this.toggleModal}>
            <Translate content='ROT_RUT_READ_MORE'/>
          </button>
        </div>
        {this.renderError()}
        {this.renderModal()}
        {this.renderExpressModal()}
      </div>
    );
  }
}

export default Hsd;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/hsd/hsd.js
 **/